import debounce from "lodash.debounce"
import { isPresentation, isDocument, isEmbed } from "./presentation-types"
import { slideImages, slideContainer, slides, stage } from "./selectors"

const PLAYER_MIN_HEIGHT = 150

const getScrollbarWidth = () => {
  return window.innerWidth - document.body.offsetWidth
}

export const getSlideContainerWidth = () => {
  const width = stage.width()
  return isDocument() ? width - getScrollbarWidth() : width
}

const clearContainerDimensions = () => {
  slideContainer.css("max-height", "")
  slideContainer.css("min-height", "")
  slides.css("max-height", "")
  slides.css("min-height", "")
  slides.css("min-width", "")
}

const clearContainerDimensionsDebounced = debounce(clearContainerDimensions, 500, { leading: true, trailing: false })

const setContainerDimensions = () => {
  slideImages
    .one("load", function () {
      const slide = $(this).closest(".slide")
      // Mark slide wrapper as loaded
      slide.addClass("loaded")

      // Fix a min-height to prevent jump of unloaded images
      if (slide.hasClass("current")) {
        if (isPresentation()) {
          if (isEmbed()) {
            const width = Math.max(document.body.offsetWidth / 2, slide.outerWidth())
            slides.css("min-width", width)
          } else {
            const height = Math.max(PLAYER_MIN_HEIGHT, slideContainer.outerHeight())
            // The -1 is necessary to prevent jumps on not yet loaded images
            slideContainer.css("min-height", height - 1)
            slideContainer.css("max-height", height)
          }
        } else if (isDocument()) {
          const height = Math.max(PLAYER_MIN_HEIGHT, slide.outerHeight())
          slides.css("min-height", height)
          slides.css("max-height", height)
        }
      }
    })
    .each(function () {
      // If images are cached in the browser 'load' may not trigger
      if (this.complete && (this.naturalWidth > 0 || this.naturalHeight > 0) && !this.src.startsWith("data:image")) {
        $(this).trigger("load") // For jQuery >= 3.0
      }
    })
}

const setContainerDimensionsDebounced = debounce(setContainerDimensions, 1000, { leading: false, trailing: true })

export const sizePlayer = () => {
  clearContainerDimensionsDebounced()
  setContainerDimensionsDebounced()
}
